import { render, staticRenderFns } from "./AdminFiltersComponent.vue?vue&type=template&id=0a2b595f&scoped=true&"
import script from "./AdminFiltersComponent.vue?vue&type=script&lang=js&"
export * from "./AdminFiltersComponent.vue?vue&type=script&lang=js&"
import style0 from "./AdminFiltersComponent.vue?vue&type=style&index=0&id=0a2b595f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2b595f",
  null
  
)

export default component.exports